var _defs, _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWindmillLoader2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.83 71.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#264653; opacity: 0.5;}.b{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M38.2,28.92c.21,1.5-1.23,7-2.28,7s-1.71-5.11-1.71-7.48c0-4.09.65-15.66,1.71-15.66S37.34,22.62,38.2,28.92Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 35.92,
    cy: 35.92,
    r: 23.14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.71,37.44c1.2-.93,6.68-2.44,7.21-1.52s-3.57,4-5.62,5.21c-3.55,2-13.89,7.27-14.42,6.36S23.69,41.33,28.71,37.44Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M40.84,41.4c-1.41-.58-5.45-4.57-4.92-5.48s5.27,1.07,7.32,2.26c3.55,2,13.24,8.39,12.72,9.31S46.72,43.8,40.84,41.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindmillLoader2);
export default __webpack_public_path__ + "static/media/windmillLoader2.fb72db95da978197c774a24e0a5820c3.svg";
export { ForwardRef as ReactComponent };